
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_6e7u6_97",
  "tools": "awsui_tools_wih1l_6e7u6_106",
  "tools-filtering": "awsui_tools-filtering_wih1l_6e7u6_112",
  "tools-align-right": "awsui_tools-align-right_wih1l_6e7u6_117",
  "tools-pagination": "awsui_tools-pagination_wih1l_6e7u6_121",
  "tools-preferences": "awsui_tools-preferences_wih1l_6e7u6_121",
  "tools-small": "awsui_tools-small_wih1l_6e7u6_127",
  "table": "awsui_table_wih1l_6e7u6_133",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_6e7u6_139",
  "wrapper": "awsui_wrapper_wih1l_6e7u6_143",
  "variant-stacked": "awsui_variant-stacked_wih1l_6e7u6_151",
  "variant-container": "awsui_variant-container_wih1l_6e7u6_151",
  "variant-embedded": "awsui_variant-embedded_wih1l_6e7u6_155",
  "has-header": "awsui_has-header_wih1l_6e7u6_158",
  "has-footer": "awsui_has-footer_wih1l_6e7u6_161",
  "cell-merged": "awsui_cell-merged_wih1l_6e7u6_175",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_6e7u6_179",
  "empty": "awsui_empty_wih1l_6e7u6_194",
  "loading": "awsui_loading_wih1l_6e7u6_198",
  "selection-control": "awsui_selection-control_wih1l_6e7u6_202",
  "selection-control-header": "awsui_selection-control-header_wih1l_6e7u6_209",
  "sticky-scrollbar": "awsui_sticky-scrollbar_wih1l_6e7u6_214",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_wih1l_6e7u6_224",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_wih1l_6e7u6_227",
  "dark-header": "awsui_dark-header_wih1l_6e7u6_235",
  "header-secondary": "awsui_header-secondary_wih1l_6e7u6_239",
  "table-has-header": "awsui_table-has-header_wih1l_6e7u6_255",
  "header-controls": "awsui_header-controls_wih1l_6e7u6_259",
  "divider": "awsui_divider_wih1l_6e7u6_273",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_6e7u6_280",
  "footer": "awsui_footer_wih1l_6e7u6_280",
  "thead-active": "awsui_thead-active_wih1l_6e7u6_289",
  "row": "awsui_row_wih1l_6e7u6_290",
  "row-selected": "awsui_row-selected_wih1l_6e7u6_291"
};
  